import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onKeyup"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("label", null, [
    _cache[1] || (_cache[1] = _createTextVNode("Console: ", -1 /* CACHED */)),
    _withDirectives(_createElementVNode("input", {
      maxlength: "7",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query_input) = $event)),
      id: "console",
      onKeydown: $setup.onKeyPress,
      onKeyup: _withKeys(_withModifiers($setup.onEscape, ["prevent"]), ["esc"])
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1), [
      [_vModelText, $setup.query_input]
    ])
  ]))
}